class ListeMariage {
	constructor(config) {
		/// On surcharge {config} par {defaults}
		/// les propriétés de {defaults} ne sont ajoutées que si elles n'existent pas
		this.config = {
			...defaults,
			...config
		};
	}

	initialize(idFormulaire) {
		let self = this;
	}

	//// UTILITIES
	_submitForm(idForm, isValid) {
		document.forms[idForm].addEventListener('submit', (event) => {
			event.preventDefault();
			if (isValid) {
				if (document.getElementById(idForm).checkValidity()) {
					let formData = new URLSearchParams(new FormData(event.target));
					fetch(event.target.action, {
						method: 'POST',
						body: formData // event.target is the form
					}).then((resp) => {
						return resp.text();
					}).then((body) => {
						return true;
					}).catch((error) => {
						console.error(error)
					});
				}
			}
		});
	}
	_datepickerFormatter(input) {
		let datePicker = input;
		if (input === undefined) {
			datePicker = document.getElementById('datePicker');
		}

		if (datePicker !== null) {
			datePicker.addEventListener('change', function (el) {
				document.getElementById('DateEvenement').value = new Intl.DateTimeFormat('fr-FR').format(new Date(el.target.value));
			});
		}
	}
}